import React from 'react';

export const RelationshipIcon = (): React.JSX.Element => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 34 34"
			width="100%"
			height="auto"
		>
			<path
				fill="currentColor"
				d="M22.917 30.208h7.291v-7.291h-7.291zM11.458 7.292a4.167 4.167 0 1 0-8.333 0 4.167 4.167 0 0 0 8.333 0m21.875 23.177a2.865 2.865 0 0 1-2.864 2.864h-7.813a2.865 2.865 0 0 1-2.864-2.864v-7.813a2.865 2.865 0 0 1 2.864-2.864h7.813a2.865 2.865 0 0 1 2.864 2.864zM14.583 7.292a7.29 7.29 0 0 1-5.729 7.12v9.546c0 .576.467 1.042 1.042 1.042h6.77v3.125h-6.77a4.167 4.167 0 0 1-4.167-4.167v-9.546a7.292 7.292 0 1 1 8.854-7.12"
			/>
		</svg>
	);
};
